module.exports = __webpack_public_path__ + "img/vision_new.c428a629.png";